export const CLIENT_ENTITY_ID = 'e9eadbe1-9e9a-476f-98b3-c9d47528fa76';
